require("./wdh-legacy/video-spot/js/base/component-video-spot.js");